/* eslint-disable jsx-a11y/anchor-is-valid */
import {Children, FC, Fragment, useEffect, useState} from 'react'
import {i18n} from '../../translate/i18n'
import {toDate, toDateTime, toMoney} from '../../utils/formater'
import {Button} from '../Button/Button'
import {Input} from '../Input/Input'
import {Loading} from '../Loading/Loading'

import {useLocation, useSearchParams} from 'react-router-dom'

import {TableSearch} from './TableSearch'
import {TableHeader} from './TableHeader'
import {TableBody} from './TableBody'
import {TableFooter} from './TableFooter'
type header = {
  key: string
  value: string
  type: string
  badge?: any
  disable?: boolean
  action?: (param: any) => void
  size?: string
  show?: boolean
  noLimit?: boolean
  noOrder?: boolean
  products?: any
}

type SubItem = {
  value: string
  props: Props
  noLimit?: boolean
}

type IndexSubitemType = {
  new: number
  old?: IndexSubitemType
}

type DropdownIconType = {
  text: string
  action: (param: any) => void
}

export type option = {
  icon: string
  iconColor?: string
  path?: string
  action?: (param: any) => void
  title?: string
  isButton?: boolean
  textButton?: string
  color?: string
  fieldToShow?: string
  valueToShow?: string
  dropdownItems?: DropdownIconType[]
  verifyConditionItem?: string
  href?: string
  verifyConditionValue?: any
}

type MetaType = {
  hasNextPage: boolean
  hasPreviousPage: boolean
  itemCount: number
  page: number
  pageCount: number
  take: number
}

export type OrderType = {
  field: string
  type: 'ASC' | 'DESC'
}

type Props = {
  data: any[]
  extendData?: any
  headers: header[]
  options?: option[]
  color?: string | 'primary'
  meta?: MetaType
  search?: boolean
  backgroundRow?: string
  subItems?: any
  onChangeData?: (take: number, page: number, search: string, order?: OrderType) => Promise<any>
  selectAllChecked?: boolean
  onSelectAll?: (checked: boolean) => void
}

const NewDatatable: FC<Props> = (props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const _location = useLocation()
  const {data, options, headers, color, meta, onChangeData, search, backgroundRow} = props
  const [stateSort, setStateSort] = useState<OrderType>({field: '', type: 'ASC'})
  const [pagination, setPagination] = useState<any[]>([])
  const [perView, setPerView] = useState<number>((meta && meta.take) || 100)
  const [perViewList, setPerViewList] = useState<object[]>([])
  const [list, setList] = useState<any[]>([])
  const [query, setQuery] = useState<string>(() => {
    const savedSearch = localStorage.getItem(`${_location.pathname}_search`)
    return savedSearch || searchParams.get('search') || ''
  })
  const [indexPagination, setIndexPagination] = useState<number>(-1)
  const [copyData, setCopyData] = useState<any[]>([])
  const [loadingTable, setLoadingTable] = useState(false)

  const prepareList = (size: number) => {
    const numbers = []
    if (size > 0) {
      for (let i = 1; i <= size; i++) {
        numbers.push(i)
      }
    }
    setList(numbers)
  }

  const find = (query: string) => {
    const normalizeString = (str: string) =>
      str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Remove acentos/especiais
        .replace(/[\.\-\/]/g, '') // Remove . / e - para pesquisa por CNPJ
        .toLowerCase()
    const normalizedQuery = normalizeString(query)
    const response: Array<any | null> = []
    data.map((item: object, index: number) => {
      Object.entries(item).map((element) => {
        if (!response.some((resItem) => resItem?.id === data[index].id)) {
          const normalizedValue = normalizeString(String(element[1]))
          if (normalizedValue === normalizedQuery) {
            response.unshift(data[index]) // Items Iguais!
          } else if (normalizedValue.includes(normalizedQuery)) {
            response.push(data[index]) // Items Semelhantes!
          }
        }
      })
    })
    if (query.length > 0) {
      searchParams.set('search', query)
      if (_location.pathname.includes('/pluginspace'))
        //Para funcionar apenas nesta tela, momentaneamente
        localStorage.setItem(`${_location.pathname}_search`, query)
    } else if (query.length === 0) {
      searchParams.delete('search')
      if (_location.pathname.includes('/pluginspace'))
        //Para funcionar apenas nesta tela, momentaneamente
        localStorage.removeItem(`${_location.pathname}_search`)
    }
    if (_location.pathname.includes('/pluginspace'))
      setSearchParams(new URLSearchParams(searchParams)) //Para funcionar apenas nesta tela, momentaneamente
    return response
  }

  const divide = (payload: Array<any> | any, divider: number | any) => {
    const divideArray = [...payload]
    return new Array(Math.ceil(divideArray.length / divider))
      .fill(null)
      .map(() => divideArray.splice(0, divider))
  }

  const sortTable = async (type: 'ASC' | 'DESC', key: string, param: any) => {
    setStateSort({field: key, type})
    const sortData: Array<any> = []
    if (onChangeData && key !== 'selected') {
      setLoadingTable(true)
      await onChangeData(
        perView,
        (meta && meta.page && parseInt(meta.page.toString()) - 1) || 1,
        query,
        {field: key, type}
      )
      setLoadingTable(false)
    } else {
      pagination.map((el: Array<any>) => {
        el.map((item: object) => {
          sortData.push(item)
        })
      })
      if (param === 'number') {
        if (type === 'DESC') {
          sortData.sort((a: any, b: any) => b[key] - a[key])
        } else {
          sortData.sort((a: any, b: any) => a[key] - b[key])
        }
      } else if (param === 'datetime') {
        if (type == 'DESC') {
          sortData.sort((a: any, b: any) => {
            const dataA: any = converterParaData(a.created ? a.created : a[key])
            const dataB: any = converterParaData(b.created ? b.created : b[key])

            return dataB - dataA
          })
        } else {
          sortData.sort((a: any, b: any) => {
            const dataA: any = converterParaData(a.created ? a.created : a[key])
            const dataB: any = converterParaData(b.created ? b.created : b[key])
            return dataA - dataB
          })
        }
      } else {
        if (type === 'DESC') {
          sortData.sort((a: any, b: any) => String(b[key]).localeCompare(String(a[key])))
        } else {
          sortData.sort((a: any, b: any) => String(a[key]).localeCompare(String(b[key])))
        }
      }
      const sortDataDivided = divide(sortData, Number(perView))
      setPagination(sortDataDivided)
      setCopyData(sortDataDivided[0])
      setIndexPagination(0)
      setLoadingTable(true)
      setTimeout(() => {
        setLoadingTable(false)
      }, 100)
    }
  }

  const showExtendData = (key: any) => {
    const newCopyData = copyData.map((i) => i)
    newCopyData.map((data: any) => {
      if (data == key) {
        if (!data.extend) data.extend = true
        else data.extend = false
      }
    })
    setCopyData(newCopyData)
  }

  function converterParaData(dataStr: any) {
    return new Date(dataStr)
  }

  useEffect(() => {
    setCopyData(data)
    const divideData = divide(data, Number(perView))
    setPagination(divideData)
    setCopyData(divideData[0])
    prepareList((meta && meta.pageCount) || divideData.length)
    if (indexPagination === -1)
      setIndexPagination((meta && meta.page && parseInt(meta.page.toString()) - 1) || 0)
    const list = [
      {select: 10, value: 10},
      {select: 25, value: 25},
      {select: 50, value: 50},
      {select: 100, value: 100},
    ]
    setPerViewList(list)
    setLoadingTable(true)
    setTimeout(() => {
      setLoadingTable(false)
    }, 100)
  }, [data])

  useEffect(() => {
    searchItems()
  }, [query])

  async function searchItems() {
    let result

    result = find(query)
    setLoadingTable(true)
    setTimeout(() => {
      setLoadingTable(false)
    }, 100)
    if (result && result.length > 0) {
      const divideData = divide(result, perView)
      setPagination(divideData)
      setCopyData(divideData[0])
      prepareList((query ? divideData.length : meta && meta.pageCount) || 0)
    } else {
      setCopyData([])
      setPagination([])
      prepareList(0)
    }
  }

  function changeItem(item: any, object: any, value: any) {
    const newData = copyData.map((c) => {
      if (c === item) {
        c[object.value] = value
      }
      return c
    })
    setCopyData(newData)
  }

  async function alterTablePerView() {
    if (query) {
      await alterDataPerSeach(query)
      return
    }

    const divideData = divide(data, Number(perView))
    setPagination(divideData)
    setCopyData(divideData[0])
    // setIndexPagination((meta && meta.page - 1) || 0)

    let prepareListData = (meta && meta.pageCount) || divideData.length

    prepareList(prepareListData)
  }

  useEffect(() => {
    alterTablePerView()
  }, [perView])

  useEffect(() => {
    if (!meta && indexPagination !== -1) setCopyData(pagination[indexPagination])
  }, [indexPagination])

  useEffect(() => {
    if (data.length > 0) {
      searchItems()
    }
  }, [data])

  const alterDataPerSeach = async (search: string) => {
    try {
      let result

      result = find(query)
      setLoadingTable(true)

      if (result && result.length > 0) {
        const divideData = divide(result, perView)
        setPagination(divideData)
        setCopyData(divideData[0])
        prepareList((query ? divideData.length : meta && meta.pageCount) || 0)
      } else {
        // aqui nao foi encontrado o que foi pesquisado, logo deve ser procurado no banco de dados
        if (onChangeData) {
          setLoadingTable(true)

          const newData = await onChangeData(perView, 1, search, {field: 'name', type: 'ASC'})
          const result = findWithData(search, newData)
          const divideData = divide(result, perView)
          setPagination(divideData)
          setCopyData(divideData[0])
          prepareList((meta && meta.pageCount) || divideData.length)

          setLoadingTable(false)
        } else {
          setCopyData([])
          setPagination([])
          prepareList(0)
        }
      }

      setTimeout(() => {
        setLoadingTable(false)
      }, 100)
    } catch (error) {}
  }

  const alterTablePerPage = async (
    perView: number,
    page: number,
    search: string,
    order?: OrderType
  ) => {
    try {
      setLoadingTable(true)

      const newPage = validatePageByViewAndQuantity(perView.toString(), meta?.itemCount ?? 0, page)

      if (onChangeData) {
        await onChangeData(perView, newPage, search, order)
      }

      setTimeout(() => {
        setLoadingTable(false)
      }, 100)
    } catch (error) {}
  }

  function validatePageByViewAndQuantity(perView: string, dataQuantity: number, position: number) {
    try {
      let page = 1

      const numberOfPages = Math.ceil(dataQuantity / parseInt(perView))

      if (position > numberOfPages) {
        setIndexPagination(numberOfPages)
        page = numberOfPages
      } else {
        page = position
      }

      return page
    } catch (error) {
      console.log(error)

      return 1
    }
  }

  return (
    <div>
      <TableSearch
        perView={perView}
        setPerView={setPerView}
        query={query}
        setQuery={setQuery}
        search={search}
        alterDataPerSeach={alterDataPerSeach}
      />
      {loadingTable ? (
        <Loading />
      ) : (
        <div className='table-responsive'>
          {copyData && data && copyData.length > 0 ? (
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              <TableHeader
                headers={headers}
                sortTable={sortTable}
                stateSort={stateSort}
                copyData={copyData}
                selectAllChecked={props.selectAllChecked}
                onSelectAll={props.onSelectAll}
              />
              <TableBody
                copyData={copyData}
                headers={headers}
                changeItem={changeItem}
                showExtendData={showExtendData}
                perView={perView}
                indexPagination={indexPagination}
                options={options}
              />
            </table>
          ) : (
            <div className='bg-gray-100 text-center fs-2 py-3 flex justify-center items-center opacity-25'>
              Nenhum item encontrado... <i className='fas fa-ghost ms-3 fs-1'></i>
            </div>
          )}

          <TableFooter
            copyData={copyData}
            data={data}
            indexPagination={indexPagination}
            perView={perView}
            setIndexPagination={setIndexPagination}
            color={color}
            pagination={pagination}
            list={list}
            alterDataPerPage={alterTablePerPage}
            meta={meta}
            stateSort={stateSort}
            query={query}
          />
          {/* end::Table */}
        </div>
      )}
      {/* end::Table container */}
    </div>
  )
}

export {NewDatatable}
export type {MetaType}
function findWithData(search: string, newData: any) {
  const normalizeString = (str: string) =>
    str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove accents/special characters
      .replace(/[\.\-\/]/g, '') // Remove . / and - for CNPJ search
      .toLowerCase()

  const normalizedQuery = normalizeString(search)
  const response: Array<any | null> = []

  newData.map((item: object, index: number) => {
    Object.entries(item).map((element) => {
      if (!response.some((resItem) => resItem?.id === newData[index].id)) {
        const normalizedValue = normalizeString(String(element[1]))
        if (normalizedValue === normalizedQuery) {
          response.unshift(newData[index]) // Exact matches
        } else if (normalizedValue.includes(normalizedQuery)) {
          response.push(newData[index]) // Partial matches
        }
      }
    })
  })

  return response
}
